const PREFIX = 'scRoundStatus';

/**
 * @param {string} partnerId
 * @param {string} gameName
 */
export function roundStatusStorageKey(partnerId, gameName) {
  return `${PREFIX}:${partnerId}:${gameName}`;
}

/**
 * @typedef {'celebrating' | 'collect_hold' | 'rollup_collect'} RoundStatusPhase
 * @typedef {{
 *   phase: RoundStatusPhase,
 *   pendingWin: number,
 *   betAmount: number,
 *   winMult: number,
 *   showCelebration: boolean,
 *   celebrationStartedAt?: number,
 *   savedAt?: number,
 * }} RoundStatusSnapshot
 */

/**
 * @param {string} key
 * @param {Omit<RoundStatusSnapshot, 'savedAt'>} status
 */
export function saveRoundStatus(key, status) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(key, JSON.stringify({ ...status, savedAt: Date.now() }));
  } catch {
    /* quota / private mode */
  }
}

/**
 * @param {string} key
 * @returns {RoundStatusSnapshot | null}
 */
export function loadRoundStatus(key) {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

/** @param {string} key */
export function clearRoundStatus(key) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
